"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenStax Highlights API
 * The highlights API for OpenStax.  Requests to this API should include `application/json` in the `Accept` header.  The desired API version is specified in the request URL, e.g. `[domain]/highlights/api/v0/highlights`. While the API does support a default version, that version will change over time and therefore should not be used in production code!
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class HighlightsApi extends runtime.BaseAPI {
    /**
     * Add a highlight with an optional note
     * Add a highlight
     */
    addHighlightRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.highlight === null || requestParameters.highlight === undefined) {
                throw new runtime.RequiredError('highlight', 'Required parameter requestParameters.highlight was null or undefined when calling addHighlight.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/highlights`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.NewHighlightToJSON(requestParameters.highlight),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.HighlightFromJSON(jsonValue));
        });
    }
    /**
     * Add a highlight with an optional note
     * Add a highlight
     */
    addHighlight(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addHighlightRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Delete a highlight. Can only be done by the owner of the highlight.
     * Delete a highlight
     */
    deleteHighlightRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteHighlight.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/highlights/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a highlight. Can only be done by the owner of the highlight.
     * Delete a highlight
     */
    deleteHighlight(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteHighlightRaw(requestParameters);
        });
    }
    /**
     * Get a highlight without its annotation data.
     * Get a highlight without its annotation data.
     */
    getHighlightRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getHighlight.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/highlights/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.HighlightFromJSON(jsonValue));
        });
    }
    /**
     * Get a highlight without its annotation data.
     * Get a highlight without its annotation data.
     */
    getHighlight(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHighlightRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get filtered highlights belonging to the calling user.  Highlights can be filtered thru query parameters:  source_type, scope_id, source_ids, and color.  Results are paginated and ordered.  When source_ids are specified, the order is order within the sources.  When source_ids are not specified, the order is by creation time.  Example call:   /api/v0/highlights?source_type=openstax_page&scope_id=123&color=yellow
     * Get filtered highlights
     */
    getHighlightsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.sourceType !== undefined) {
                queryParameters['source_type'] = requestParameters.sourceType;
            }
            if (requestParameters.scopeId !== undefined) {
                queryParameters['scope_id'] = requestParameters.scopeId;
            }
            if (requestParameters.sets) {
                queryParameters['sets'] = requestParameters.sets.join(runtime.COLLECTION_FORMATS["csv"]);
            }
            if (requestParameters.sourceIds) {
                queryParameters['source_ids'] = requestParameters.sourceIds.join(runtime.COLLECTION_FORMATS["csv"]);
            }
            if (requestParameters.colors) {
                queryParameters['colors'] = requestParameters.colors.join(runtime.COLLECTION_FORMATS["csv"]);
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.perPage !== undefined) {
                queryParameters['per_page'] = requestParameters.perPage;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/highlights`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.HighlightsFromJSON(jsonValue));
        });
    }
    /**
     * Get filtered highlights belonging to the calling user.  Highlights can be filtered thru query parameters:  source_type, scope_id, source_ids, and color.  Results are paginated and ordered.  When source_ids are specified, the order is order within the sources.  When source_ids are not specified, the order is by creation time.  Example call:   /api/v0/highlights?source_type=openstax_page&scope_id=123&color=yellow
     * Get filtered highlights
     */
    getHighlights(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHighlightsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get summary of highlights (counts per source, etc) belonging to the calling user.  Highlights can be filtered thru query parameters:  source_type, scope_id, and color.  Results are not paginated.  Example call:   /api/v0/highlights/summary?source_type=openstax_page&scope_id=123&color=#ff0000
     * Get summary of highlights (counts per source, etc)
     */
    getHighlightsSummaryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.sourceType !== undefined) {
                queryParameters['source_type'] = requestParameters.sourceType;
            }
            if (requestParameters.scopeId !== undefined) {
                queryParameters['scope_id'] = requestParameters.scopeId;
            }
            if (requestParameters.sets) {
                queryParameters['sets'] = requestParameters.sets.join(runtime.COLLECTION_FORMATS["csv"]);
            }
            if (requestParameters.colors) {
                queryParameters['colors'] = requestParameters.colors.join(runtime.COLLECTION_FORMATS["csv"]);
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/highlights/summary`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.HighlightsSummaryFromJSON(jsonValue));
        });
    }
    /**
     * Get summary of highlights (counts per source, etc) belonging to the calling user.  Highlights can be filtered thru query parameters:  source_type, scope_id, and color.  Results are not paginated.  Example call:   /api/v0/highlights/summary?source_type=openstax_page&scope_id=123&color=#ff0000
     * Get summary of highlights (counts per source, etc)
     */
    getHighlightsSummary(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHighlightsSummaryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Update a highlight
     * Update a highlight
     */
    updateHighlightRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateHighlight.');
            }
            if (requestParameters.highlight === null || requestParameters.highlight === undefined) {
                throw new runtime.RequiredError('highlight', 'Required parameter requestParameters.highlight was null or undefined when calling updateHighlight.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/highlights/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.HighlightUpdateToJSON(requestParameters.highlight),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.HighlightFromJSON(jsonValue));
        });
    }
    /**
     * Update a highlight
     * Update a highlight
     */
    updateHighlight(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateHighlightRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.HighlightsApi = HighlightsApi;
/**
    * @export
    * @enum {string}
    */
var GetHighlightsSourceTypeEnum;
(function (GetHighlightsSourceTypeEnum) {
    GetHighlightsSourceTypeEnum["OpenstaxPage"] = "openstax_page";
})(GetHighlightsSourceTypeEnum = exports.GetHighlightsSourceTypeEnum || (exports.GetHighlightsSourceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHighlightsSetsEnum;
(function (GetHighlightsSetsEnum) {
    GetHighlightsSetsEnum["Userme"] = "user:me";
    GetHighlightsSetsEnum["Curatedopenstax"] = "curated:openstax";
})(GetHighlightsSetsEnum = exports.GetHighlightsSetsEnum || (exports.GetHighlightsSetsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHighlightsColorsEnum;
(function (GetHighlightsColorsEnum) {
    GetHighlightsColorsEnum["Yellow"] = "yellow";
    GetHighlightsColorsEnum["Green"] = "green";
    GetHighlightsColorsEnum["Blue"] = "blue";
    GetHighlightsColorsEnum["Purple"] = "purple";
    GetHighlightsColorsEnum["Pink"] = "pink";
})(GetHighlightsColorsEnum = exports.GetHighlightsColorsEnum || (exports.GetHighlightsColorsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHighlightsSummarySourceTypeEnum;
(function (GetHighlightsSummarySourceTypeEnum) {
    GetHighlightsSummarySourceTypeEnum["OpenstaxPage"] = "openstax_page";
})(GetHighlightsSummarySourceTypeEnum = exports.GetHighlightsSummarySourceTypeEnum || (exports.GetHighlightsSummarySourceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHighlightsSummarySetsEnum;
(function (GetHighlightsSummarySetsEnum) {
    GetHighlightsSummarySetsEnum["Userme"] = "user:me";
    GetHighlightsSummarySetsEnum["Curatedopenstax"] = "curated:openstax";
})(GetHighlightsSummarySetsEnum = exports.GetHighlightsSummarySetsEnum || (exports.GetHighlightsSummarySetsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHighlightsSummaryColorsEnum;
(function (GetHighlightsSummaryColorsEnum) {
    GetHighlightsSummaryColorsEnum["Yellow"] = "yellow";
    GetHighlightsSummaryColorsEnum["Green"] = "green";
    GetHighlightsSummaryColorsEnum["Blue"] = "blue";
    GetHighlightsSummaryColorsEnum["Purple"] = "purple";
    GetHighlightsSummaryColorsEnum["Pink"] = "pink";
})(GetHighlightsSummaryColorsEnum = exports.GetHighlightsSummaryColorsEnum || (exports.GetHighlightsSummaryColorsEnum = {}));
